import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';

import MessageChat from '../Message/Message';
import SendMessage from '../SendMessage/SendMessage';
import { useImageClipboard } from '../../hooks/imageClipboard';

import './messageContainer.css';

interface Message {
  seqMensagem: number;
  texto: string;
  seqUsuario: number;
  nomeCliente: string;
  dtEnvioMensagem: string;
}

interface Messages {
  messages: Message[];
  getMessages: (message: Message[]) => void;
}

const MessageContainer: React.FC<any> = ({
  messages,
  getMessages,
}: Messages) => {
  const messageRef = useRef<HTMLDivElement>(null);
  const [showModalImageChat, setShowModalImageChat] = useState(false);
  const [urlImageChat, setUrlImageChat] = useState('');
  const { imageFile } = useImageClipboard();

  useEffect(() => {
    if (messageRef && messageRef.current) {
      const { scrollHeight, clientHeight } = messageRef.current;
      messageRef.current.scrollTo({
        left: 0,
        top: scrollHeight - clientHeight,
        behavior: 'smooth',
      });
    }
  }, [messages]);

  useEffect(() => {
    const imgElements = document.querySelectorAll('.clickable-img');

    function handleExibeImagamChat(src: string): void {
      setUrlImageChat(src);
      setShowModalImageChat(true);
    }

    imgElements.forEach((img) => {
      const src = String(img.getAttribute('src'));

      img.removeEventListener('click', () => handleExibeImagamChat(src));
      img.addEventListener('click', () => handleExibeImagamChat(src));
    });
  }, [messages]);

  return (
    <div className="d-flex flex-column h-100">
      {/* componente para exibir a imagem do chat */}
      <div
        className={`position-fixed text-center bg-dark bg-opacity-75 d-flex justify-content-center align-items-center ${
          !showModalImageChat ? 'visually-hidden' : ''
        }`}
        style={{
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          zIndex: 9999,
        }}
      >
        <div
          className="position-absolute d-flex flex-row text-center bg-dark bg-opacity-50 overflow-auto border-1 rounded-3"
          style={{
            maxWidth: '80vw',
            maxHeight: '90vh',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <div className="overflow-auto ">
            <img
              className="m-3"
              src={urlImageChat}
              style={{ maxHeight: '100%', maxWidth: '80rem' }}
              alt="imagem chat"
            />

            <Button
              variant="warning"
              className="ms-1 me-4 mb-3"
              style={{ maxWidth: '10rem' }}
              onClick={() => {
                setShowModalImageChat(!showModalImageChat);
              }}
            >
              Fechar
            </Button>
          </div>
        </div>
      </div>

      <div
        className="div-container-msg-main position-relative overflow-auto flex-grow-1"
        ref={messageRef}
      >
        <div
          id="divMensagens"
          className="overflow-auto d-flex flex-column "
          style={{ flex: '1' }}
        >
          {messages.map((m: Message) => {
            return (
              <div
                key={m.seqMensagem}
                className={`d-flex flex-column ms-md-3 me-md-3 ms-1 me-1 ${
                  m.seqUsuario ? 'align-items-start' : 'align-items-end'
                }`}
              >
                <MessageChat message={m} />
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-100 div-envia-msg d-flex flex-shrink-0">
        <SendMessage getMessages={getMessages} />
      </div>
    </div>
  );
};

export default MessageContainer;
